module.exports = __webpack_public_path__ + "static/exterior-3-797747a7b1a608f1e66ab29326193455.jpg";